import { render, staticRenderFns } from "./YourHome.vue?vue&type=template&id=562f2b15"
import script from "./YourHome.vue?vue&type=script&lang=js"
export * from "./YourHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports